import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";
import { Button, SxProps } from "@mui/material";
import { AppTheme } from "../../utils/theme";

interface BasicDatepickerProps {
	value?: Dayjs | null;
	label: string;
	onChange?: (value: Dayjs | null) => void;
	onClear?: () => void;
	sx?: SxProps<AppTheme> | undefined;
	disableFuture?: boolean;
	ianaTimeZone?: string;
}

const BasicDatepicker: React.FC<BasicDatepickerProps> = ({
	value,
	label,
	onChange,
	onClear,
	sx,
	disableFuture = true,
	ianaTimeZone,
}) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Box
				sx={{
					minWidth: 180,
					display: "flex",
					flexGrow: 1,
					maxWidth: "100%",
					height: "3.5rem",
					...sx,
				}}
			>
				<FormControl fullWidth sx={{ height: "3.5rem" }}>
					<DatePicker
						timezone={ianaTimeZone}
						value={value}
						label={label}
						disableFuture={disableFuture ?? true}
						onChange={onChange}
					/>
				</FormControl>
				{onClear && (
					<Button onClick={onClear} sx={{ ml: 1, height: "3.5rem" }}>
						Clear
					</Button>
				)}
			</Box>
		</LocalizationProvider>
	);
};

export default BasicDatepicker;
